import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17411: Фича включения адмитада */
export const isAdmitadEnabled = isFeature('admitad');
